import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/product/ProductCard";
import { ArrowRight } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export default function FeaturedProducts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/products", { params: { featured: true, limit: 8 } })
      .then(({ data }) => setItems(data.items || []))
      .finally(() => setLoading(false));
  }, []);
  return (
    <section data-testid="home-featured" className="bg-slate-50 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#0055FF]">Featured Inventory</div>
            <h2 className="mt-2 font-heading text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">Real products, live from our catalog</h2>
            <p className="text-sm text-slate-500 mt-2 max-w-xl">Every listing shows real prices, manufacturers, and part numbers sourced from our active eBay inventory.</p>
          </div>
          <Link to="/shop" className="text-sm text-slate-700 hover:text-[#0055FF] inline-flex items-center gap-1">
            View all <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {loading
            ? Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="rounded-xl border border-slate-200 bg-white overflow-hidden">
                  <Skeleton className="aspect-[4/3] w-full" />
                  <div className="p-4 space-y-2">
                    <Skeleton className="h-4 w-3/4" />
                    <Skeleton className="h-3 w-1/2" />
                    <Skeleton className="h-6 w-24" />
                  </div>
                </div>
              ))
            : items.map((p, i) => <ProductCard key={p.product_id} product={p} index={i} />)}
        </div>
      </div>
    </section>
  );
}
